import * as React from 'react';
import {Field, FieldArray, Form, Formik} from "formik";
import {TextField, Select, CheckboxWithLabel} from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {AddCircle, RemoveCircle} from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";

class FolderTemplateForm extends React.Component {

    render() {
        return <Formik
            initialValues={this.props.template}
            validate={this.validate}
            onSubmit={this.props.save}
            render={({ values, isSubmitting }) => (
                <Form style={{width: '50%'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Field name='name' label={'Name'} component={TextField} value={values.name} fullWidth/>
                        </Grid>
                        <Grid item xs={12}>
                            <Field name='category' label={'Category'} component={TextField} value={values.category} fullWidth/>
                        </Grid>
                        <Grid item xs={12}>
                            <Field name='description' label={'Description'} component={TextField} value={values.description} fullWidth/>
                        </Grid>
                        <Grid item xs={12}>
                            <FieldArray
                                name='fields'
                                render={arrayHelpers => (
                                    <Box mt={1}>
                                        <Typography variant={'h5'} component={'span'}>
                                            Fields
                                            <Tooltip title={'Add a custom field'}>
                                                <IconButton onClick={() => arrayHelpers.push({name: '', type: 'text_short', quick_search: false})}>
                                                    <AddCircle/>
                                                </IconButton>
                                            </Tooltip>
                                        </Typography>
                                        {values.fields.map((nextValue, index) => (
                                            <Grid container key={index} spacing={1}>
                                                <Grid item xs={4}>
                                                    <Field name={`fields[${index}][name]`} placeholder={'Name'} component={TextField} value={nextValue.name} fullWidth/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Field name={`fields[${index}][type]`} component={Select} value={nextValue.type} fullWidth>
                                                        {this.props.fields.map((nextField) => {
                                                            return <MenuItem key={nextField.id} value={nextField.id}>
                                                                {nextField.name}
                                                            </MenuItem>;
                                                        })}
                                                    </Field>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Field name={`fields[${index}][quick_search]`} Label={{label: 'Quick Search?'}} component={CheckboxWithLabel} value={nextValue.quick_search}/>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Tooltip title={'Remove this field'}>
                                                        <IconButton onClick={() => arrayHelpers.remove(index)} xs={2}>
                                                            <RemoveCircle/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Box>
                                )}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant='contained' color='primary' disabled={isSubmitting} type={'submit'}>
                                {this.props.submitButtonText}
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant='contained' color='secondary' disabled={isSubmitting} onClick={this.props.cancel}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Form>
            )}/>;
    };

    validate = (values) => {
        let errors = {};
        if (!values.name) {
            errors.name = 'Required';
        }
        return errors;
    };
}

export default FolderTemplateForm;
